import React from "react";
import { useNavigate } from "react-router-dom";
import { loadStudentMenuI18n } from "../../../i18n/loaders/studentMenu.i18n";
import { useI18nLoader } from "../../../i18n/loaders/useI18nLoader";
import { useTranslation } from "react-i18next";
import { handleSmartBack } from "../../../../utils/navigationHelper";

const BackButton = ({ fallbackPath = "/", variant = "black" }) => {
  const { t } = useTranslation("common");
  useI18nLoader(loadStudentMenuI18n);
  const navigate = useNavigate();

  const handleBack = () => {
    handleSmartBack(navigate, fallbackPath);
  };
  const textColorClass = variant === "white" ? "text-white" : "text-dark";

  return (
    <>
      <p
        onClick={handleBack}
        className={`mb-1 backlink ${textColorClass}`}
        style={{ cursor: "pointer" }}
      >
        <i className="fa-solid fa-angle-left"></i> {t("back")}
      </p>
    </>
  );
};

export default BackButton;
